var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.316 6.8936L19.3479 6.9007H5.6526L9.9568 2.5866C10.166 2.375 10.2833 2.0894 10.2833 1.7918C10.2833 1.4943 10.166 1.2087 9.9568 0.997101L9.2879 0.326801C9.0779 0.117501 8.7935 0 8.497 0C8.2005 0 7.9161 0.117501 7.7061 0.326801L0.326302 7.7066C0.117302 7.9178 0 8.203 0 8.5002C0 8.7974 0.117302 9.0826 0.326302 9.2938L7.7061 16.6736C7.9162 16.8827 8.2006 17 8.497 17C8.7934 17 9.0778 16.8827 9.2879 16.6736L9.9568 16.0024C10.0609 15.8988 10.1433 15.7755 10.1993 15.6398C10.2553 15.5041 10.2838 15.3585 10.2832 15.2117C10.2837 15.0671 10.2551 14.9238 10.1991 14.7905C10.143 14.6572 10.0606 14.5365 9.9568 14.4358L5.6041 10.0969H19.3312C19.6325 10.0905 19.9194 9.9671 20.1313 9.7528C20.3431 9.5386 20.4633 9.2503 20.4663 8.949V8.0008C20.4584 7.7022 20.3333 7.4187 20.1181 7.2115C19.9028 7.0043 19.6147 6.8901 19.316 6.8936Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.bc87c4e4da540667e2f7907a8722e509.svg";
export { ForwardRef as ReactComponent };